

/*

The MIT License (MIT)

 Copyright (c) Software Farm, Inc. 

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/

import React from 'react';
import ZUtil from './zutil';
import { APP } from './App';
import ZNetwork from './znetwork';
import WHint from './whint';
import ZProps from './zprops';
import AMCTransactionsManagerFactory from './AMCTransactions';
import ZLog from './zlog';

/*
 * Builds forms based on an array of form fields passed
 * in as a property.
 *
 */
export default class AMCForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
		this.population = {};
	}
	validate() {
		var properties = {};
		var errors = this.collectPropertiesAndErrors(properties);
		this.setState({errors: errors});
		return Object.keys(errors).length > 0 ? null : properties;
	}
	collectPropertiesAndErrors(properties) {
		var value, f, data, errors = {}, fields = this.fields;
ZLog.log("collectPropertiesAndErrors this.fields: ", this.fields);
		for (var i = 0; i < fields.length; ++i) {
			f = fields[i];
			value = null;
			data = this.population[f.field];
			if (f.kind === "annotation") {
				continue;
			}
			ZLog.debug("amcform f", {f: f});
			if (f.kind === "radio") {
				value = ZUtil.getRadioButtonsSelectedValue(f.field); 
			} else if (f.kind === "boolean") {
				value = ZUtil.getCheckboxButtonsSelectedValue(f.field).length > 0;
			} else if (f.kind === "checkboxes") {
				value = ZUtil.getCheckboxButtonsSelectedValue(f.field).sort(); 
			} else if (f.kind === "images") {
				value = this.props.values[f.field];
			} else if (f.kind === "image" || f.kind === "upload") {
				value = this.props.values[f.field];
			} else if (f.kind === "cloudinary") {
				if (data.thumbnail_url) {
					value = f.size === "thumb" ? data.thumbnail_url.replace("c_limit,h_60,w_90", "c_limit,h_150,w_150") : data.thumbnail_url.replace("c_limit,h_60,w_90", "c_limit,h_1000,w_1500");
				}
				if (!value) {
					value = f.defaultvalue;
				}
ZLog.log("amcform cloudinary", {value: value});
//https://res.cloudinary.com/automaticai/image/upload/t_big_thumb/v1580820780/things/hifi-advice-logo_doody4.png
//https://res.cloudinary.com/automaticai/image/upload/c_limit,h_60,w_90/v1580820780/things/hifi-advice-logo_doody4.png
			} else {
				value = document.getElementById(f.id).value;
			}
			ZLog.debug("AMCForm.collectPropertiesAndErrors value=" + value);
			if (!value && f.kind !== "boolean") {
				value = "";
			}
			if (f.required && (value.push ? value.length : value.trim().length) === 0) {
				errors[f.field] = "This field cannot be blank";
				if (f.kind === "checkboxes") {
					ZUtil.setCheckboxButtonsSelectedValues(f.id, f.choices);
				} else {
					properties[f.field] = value;
				}
				ZLog.debug("ERROR Cannot be blank");
			} else {
				if (f.kind === "number") {
					value = parseFloat(value);
				} else if (f.kind === "integer") {
					value = parseInt(value, 10);
				}
				properties[f.field] = value;
			}
		}
ZLog.log("amcform cloudinary", {avatar: properties.avatar});
		return errors;
	}
	onSave(e) {
		var properties = this.validate();
		if (properties) {
			this.props.onSave(properties);
		}
	}
	onChange = () => {
		ZProps.set("page_has_changed", true);
		if (this.props.onChange || this.props.onInvalidChange) {
			var properties = this.validate();
			if (properties) {
				this.props.onChange(properties);
			} else if (this.props.onInvalidChange) {
				properties = {};
				this.collectPropertiesAndErrors(properties);
				this.props.onInvalidChange(properties);
			}
		}
	}
	buttonClicked(cb, e) {
		cb(this, e);
	}
	onDeleteImage(files_input_id, field_name) {
		this.population[field_name] = null;
		this.onChange();
	}
	onSubmitImages(files_input_id, field_name) {
		var files_input = document.getElementById(files_input_id);
		var files = files_input.files;
		var numfiles = files.length; // Object.keys(files).length;
		if (files.length === 0) {
			this.population[field_name] = null;
			this.onChange();
			return;
		} 
		for (var i = 0; i < numfiles; ++i) {
			if (!ZUtil.isImage(files[i].name)) {
				APP.setError(files[i].name + " is not an image. Only images can be uploaded.");
				this.population[field_name] = null;
				this.onChange();
				return;
			}
		}
		APP.setWorking(true);
		ZNetwork.uploadImages(ZProps.get("user").uri + "-" + Date.now(), files, (err, baseurl) => {
			if (err) {
				APP.setError("Sorry. Image is too large or some other kind of error");
			} else if (baseurl) {
				ZUtil.waitForSuccessfulImageLoad(baseurl + "/0.jpg", 500, 8000, (err) => {
					APP.setWorking(false);
					this.population[field_name]["image"] = baseurl + "/0.jpg";
					this.onChange();
				});
			} else {
				APP.setWorking(false);
			}
		});
		files_input.value = '';
	}
	onSubmitImage(files_input_id, field_name) {
		var files_input = document.getElementById(files_input_id);
		var files = files_input.files;
		if (files.length !== 1 || !ZUtil.isImage(files[0].name)) {
			this.population[field_name] = null;
			this.onChange();
		} else {
			APP.setWorking(true);
			ZNetwork.uploadImage(ZProps.get("user").uri + "-" + this.props.values.id, files[0], files[0].name, (err, url) => {
				if (err) {
					APP.setError("Sorry. Image is too large or some other kind of error");
				} else if (url) {
					ZUtil.waitForSuccessfulImageLoad(url, 500, 8000, (err) => {
						APP.setWorking(false);
						this.population[field_name] = url;
						this.onChange();
					});
				} else {
					APP.setWorking(false);
				}
			});
			files_input.value = '';
		}
	}
	// https://github.com/willwebberley/NodeDirectUploader/blob/master/views/account.html
	onUploadSubmit(files_input_id, field_name, e) {
		var files = document.getElementById(files_input_id).files;
		var file = files[0];
		if (file) {
			//delete this.state.errors[field_name];
			this.setState({ errors: { ...this.state.errors, [field_name]: null } });
			this.props.onUploading(file);
		}
        }
	onButtonsCallback(callback, label, e) {
		callback(label, e);
	}
	onCloudinary(f) {
		let user = ZProps.get("user");
		if (user.plan === "guest") {
			return this.setState({ errors: { [f.field]: "Only members can upload avatars and banners" } });
		}
		let MAPPING = { things: "things", avatars: "avatars", banners: "banners" };
		window.cloudinary.openUploadWidget({ uploadPreset: MAPPING[f.folder] }, (error, result) => {
			if (result && result.event === "success") {
				let file = result.info;
ZLog.info("cloudinary file", { file: file });
				let info = { name: file.name, size: file.size, type: file.type, url: file.secure_url, thumbnail_url: file.thumbnail_url };
				this.population[f.field].thumbnail_url = info.thumbnail_url;
				// f.image_url = info.url; // original image, unused? deprecated? secure_url;
      				ZLog.debug('Cloudinary result: ', { thumbnail_url: this.population[f.field] } ); 
				this.onChange();
				this.setState({ overrides: { [f.field]: this.population[f.field].thumbnail_url } });
				if (this.props.onChange || this.props.onInvalidChange) {
					this.forceUpdate();
				}
//ZLog.info("cloudinary f.thiumbnail=", { thumbnail_url: f.thumbnail_url });
//ZLog.log("amcform f", {f: f});
			}
		});
	}
	render() {
		var { fields, values, readonly_props, options } = this.props;
		var { overrides, errors } = this.state;
		errors = errors || {};
		overrides = overrides || {};
		options = options || {}
//console.log("Form fields=" + ZUtil.inspect(fields));
		var rows = [], f, id, fieldwidget, lastsection, sectionrows, tables = [], defval, key, disabled, i, j;

		//console.error("AMCForm - fields.length=" + fields.length);
		//console.log("readonly_props.length=" + Object.keys(readonly_props || {}).length);
		//ZLog.log("readonly_props=" ,{readonly_props: readonly_props});
		//ZLog.log("values=" ,{values: values});
		this.fields = [];
		(fields || []).forEach( f => {
			this.fields.push( Object.assign({}, f) );
			this.population[f.field] = this.population[f.field] || {};
		});

//ZLog.log("fields was", { fields: fields});
//ZLog.log("fields now", { fields: this.fields});
		fields = this.fields;
		//fields = ZUtil.clone(fields); generates errors cloneing annotations i.e. JSX
		//this.fields = fields;
		// sort fields so readonly come first
		if (options.sort_readonly_props && readonly_props) {
			let readonly_fields = [];
			let free_fields = [];
			for (i = 0; i < fields.length; ++i) {
				if (readonly_props[fields[i].field] || fields[i].readonly) {
					readonly_fields.push(fields[i]);
				} else {
					free_fields.push(fields[i]);
				}
			}
			fields = readonly_fields.concat(free_fields);
		}
		readonly_props = readonly_props || {};
		// console.log("now fields.length=" + fields.length);
		for (i = 0; i < fields.length; ++i) {
			f = fields[i];
			if (f.hidden) {
				continue;
			}
			id = ZUtil.idify(f.field) + "-" + i;
			f.id = id;
			f.defaultvalue = f.defaultvalue || f["default"];
			defval = values[f.field] || f.defaultvalue;
			key = i + (values.id || "") + (this.props.forceformupdate ? Date.now() : '') + "-" + defval; // gotmodel get more?  + "-" + defval;
			disabled = readonly_props[f.field] || f.disabled || f.readonly ? "disabled": null;
			switch (f.kind) {
				case "url" :
					fieldwidget = <input className={"AMCFormURLTextField" + (errors[f.field] ? " AMCFormFieldError" : "")} title={errors[f.field] || ""} type="url" key={key} defaultValue={defval} id={id} placeholder={f.placeholder} required={!!f.required} onChange={this.onChange.bind(this)}/>
					break;
				case "string" :
				case "password" :
					// !nocr
					if (!f.cr) {
						fieldwidget = <input className={"AMCFormLongTextField" + (f.buttons ? " AMCFormLongTextFieldAuto" : "") + (errors[f.field] ? " AMCFormFieldError" : "") + (disabled ? " AMCFormFieldDisabled" : "")} title={errors[f.field] || ""} type={f.kind === "string" ? "text" : f.kind} key={key} defaultValue={defval} id={id} disabled={disabled} placeholder={f.placeholder} required={!!f.required} onChange={this.onChange.bind(this)}/>
						break;
					}
					f.rows = 1;
				 	// we now use resizable textarea for textfield if f.cr is set 
					/* falls through */
				case "text" :
					disabled = readonly_props[f.field] || f.disabled ? "disabled": null;
					fieldwidget = <textarea className={"AMCFormLongTextField" + (errors[f.field] ? " AMCFormFieldError" : "") + (disabled ? " AMCFormFieldDisabled" : "")} title={errors[f.field] || ""} rows={f.rows || 2} key={key} defaultValue={defval} id={id} disabled={disabled} placeholder={f.placeholder} required={!!f.required} onChange={this.onChange.bind(this)}></textarea>
					break;
				case "radio" :
					fieldwidget = [];
					for (j = 0; j < f.choices.length; ++j) {
						fieldwidget.push ( <span key={"radio" + key + i + ":" + j} className="AMCFormRadioButtonChoice"><input type="radio" id={f.id + "" + j} name={f.field} value={f.choices[j]}  defaultChecked={values[f.field] ? values[f.field] === f.choices[j] : (f.defaultvalue === f.choices[j] || j === 0)} onChange={this.onChange.bind(this)} onClick={this.onChange.bind(this)} /> <label htmlFor={f.id + "" + j}>{f.choices[j]}</label></span> );
					}
					break;
				case "menu" :
					fieldwidget = [];
					f.choices = f.choices || [];
					for (j = 0; j < f.choices.length; ++j) {
//console.log("f.field=" + f.field);
//console.log("f.choices[j]=" + f.choices[j]);
//console.log("values[f.field]=" + values[f.field]);
//console.log("defaultChecked=" + (values[f.field] ? values[f.field] === f.choices[j] : (f.defaultvalue === f.choices[j] || j === 0)));
						fieldwidget.push ( <option key={"menuoption" + key + i + ":" + j} className="AMCFormOptionMenuItem" id={f.id + "" + j} name={f.field} value={f.choices[j]}  onChange={this.onChange.bind(this)} onClick={this.onChange.bind(this)}>{f.choices[j]}</option> );
					}
					fieldwidget = [<select key={"menu" + key + i + ":" + j} className={disabled ? "AMCFormFieldDisabled" : ""} readOnly={disabled} id={f.id} disabled={disabled} value={values[f.field] || f.defaultvalue} onChange={this.onChange.bind(this)}>{fieldwidget}</select>]
					break;
				case "boolean" :
					fieldwidget = <input type="checkbox" id={f.id} name={f.field} value={f.field} disabled={disabled}  defaultChecked={defval} onChange={this.onChange.bind(this)} />;
					break;
				case "checkboxes" :
					fieldwidget = [];
					for (j = 0; j < f.choices.length; ++j) {
						let checked = values[f.field] && values[f.field].indexOf(f.choices[j]) !== -1;
						fieldwidget.push ( <span className="AMCFormCheckBox" key={f.id + "-" + j + " " + checked}><input type="checkbox" id={f.id + "" + j} name={f.field} value={f.choices[j]}  disabled={disabled} defaultChecked={checked} onChange={this.onChange.bind(this)} /> <label htmlFor={f.id + "" + j}>{f.choices[j]}</label></span> );
					}
					if (errors[f.field]) {
						// fieldwidget.push( <div className="AMCFormFieldError">{errors[f.field]}</div> );
					}
					break;
				case "integer" :
				case "number" :
					fieldwidget = [<input type="number"  className={(errors[f.field] ? " AMCFormFieldError" : "") + (disabled ? " AMCFormFieldDisabled" : "")} title={errors[f.field] || ""} key={key} defaultValue={defval} id={id} placeholder={f.placeholder} step={f.step || 1} min={f.min || Number.MIN_SAFE_INTEGER} max={f.max || Number.MAX_SAFE_INTEGER} disabled={disabled} required={!!f.required} onChange={this.onChange.bind(this)} />]
					break;
				case "upload" :
					fieldwidget = <form className="AMCFormImageUploader"  key={key} method="post" onSubmit={this.onUploadSubmit.bind(this, id, f.field)} encType="multipart/form-data">
						<input id={id} className="AMCFormImageUploaderFilenameInput" title="Upload" type="file" disabled={readonly_props[f.field] || f.disabled ? "disabled": null} onChange={this.onUploadSubmit.bind(this, id, f.field)}/>
						{ errors[f.field] ? <span className="AMCFormUploaderMessage AMCFormFieldError"> {errors[f.field]}</span> : <span className="AMCFormUploaderMessage">{defval}</span> }
					</form>
					break;
				case "image" :
					fieldwidget = <form className="AMCFormImageUploader"  key={key} method="post" onSubmit={this.onSubmitImage.bind(this, id, f.field)} encType="multipart/form-data">
						<span>{values[f.field] ? <span className="AMCFormImagePreviewThumbContainer"><img alt="" className="AMCFormImagePreviewThumb" src={values[f.field]} /><img alt="delete" className="AMCFormImageDeleteButton" src="/images/close.png" onClick={this.onDeleteImage.bind(this, id, f.field)} /></span> : ''}
						<input id={id} className="AMCFormImageUploaderFilenameInput" title="Set image" type="file" disabled={readonly_props[f.field] || f.disabled ? "disabled": null} onChange={this.onSubmitImage.bind(this, id, f.field)}/>
						 </span>
					</form>
					break;
				case "images" :
					fieldwidget = <form className="AMCFormImageUploader"  key={key} method="post" onSubmit={this.onSubmitImage.bind(this, id, f.field)} encType="multipart/form-data">
						<input id={id} className={"AMCFormImageUploaderFilenameInput" + (disabled ? " AMCFormFieldDisabled" : "")} title="Upload images" type="file" onChange={this.onSubmitImages.bind(this, id, f.field)} multiple="multiple" disabled={disabled ? "disabled" : null} />

					</form>
					break;
				case "annotation" :
					fieldwidget = f.annotation;
					break;
				case "cloudinary" :
ZLog.log("f.field=" + f.field);
ZLog.log("overrides[f.field]=" + overrides[f.field]);
					fieldwidget = 
						<span key={overrides[f.field] || values[f.field]} >{overrides[f.field] || values[f.field] ? <span className="AMCFormImagePreviewThumbContainer"><img alt="" className="AMCFormImagePreviewThumb" src={ overrides[f.field] || values[f.field] } /><img alt="delete" className="AMCFormImageDeleteButton" src="/images/close.png" onClick={this.onDeleteImage.bind(this, id, f.field)} /></span> : <span className="AMCFormImagePreviewThumbContainerEmpty"></span>}
						<div className={"AMCFormImageUploaderButton" + (disabled ? " AMCFormFieldDisabled" : "")} onClick={ disabled ? null :  this.onCloudinary.bind(this, f) }>{f.label || "Upload image"}</div>
						</span>
					break;
				default: 
					console.error("Unknown field kind in AMCForm: " + f.kind);
					fieldwidget = "Unknown field kind in AMCForm: " + f.kind;
					break;
			}
			if (f.units) {
				if (typeof fieldwidget.push !== "function") {
					fieldwidget = [fieldwidget];
				}
				fieldwidget.push(<span key={key + "units"} >&nbsp;{f.units}</span>);
			}
			if (f.buttons) {
				if (typeof fieldwidget.push !== "function") {
					fieldwidget = [fieldwidget];
				}
				for (let b = 0; b < f.buttons.labels.length; ++b) {
					let label = f.buttons.labels[b];
				 	fieldwidget.push(<button className="AMCButton" key={label} onClick={this.onButtonsCallback.bind(this, f.buttons.callback, f.buttons.cmds[b])} >{label}</button>);
				}
			}
			if (f.hintr) {
				if (typeof fieldwidget.push !== "function") {
					fieldwidget = [fieldwidget];
				}
				fieldwidget.push(<WHint key={"hint" + f.id} hint={f.hint} />);
			}
			if (f.section !== lastsection) {
				if (rows.length > 0) {
					tables.push(<table><tbody>{rows}</tbody></table>);
					rows = [];
				} else if (sectionrows) {
					tables.push(<fieldset><legend>{lastsection}</legend><table><tbody>{sectionrows}</tbody></table></fieldset>);
				}
				lastsection = f.section;
				sectionrows = f.section ? [] : null;
			}
			let row;
			if (this.props.tableless) {
				row = f.label !== "none" ? <div key={f.id + " " + f.label} className={"AMCFormRow" + (readonly_props[f.field] ? " AMCFormRowReadOnly" : "")}><span><label htmlFor={id}>{f.name}{f.required ? <span className="AMCFormRequiredField">*</span> : '' }{f.hint ? <WHint key={"hint" + f.id} hint={f.hint} /> : ''}</label></span><span className="AMCFormRowFieldsColumn">{fieldwidget}</span></div> : <div key={f.id + f.label} className="AMCFormRow"><span></span><span>{fieldwidget}</span></div>;
			} else {
				row = f.label !== "none" ? <tr key={f.id + " " + f.label} className="AMCFormRow"><td><label htmlFor={id}>{f.name}{f.required ? <span className="AMCFormRequiredField">*</span> : '' }{f.hint ? <WHint key={"hint" + f.id} hint={f.hint} /> : ''}</label></td><td className="AMCFormRowFieldsColumn">{fieldwidget}</td></tr> : <tr key={f.id + f.label} className="AMCFormRow"><td></td><td>{fieldwidget}</td></tr>;
			}
			if (f.section) {
				sectionrows.push(row); 
			} else {
				rows.push(row);
			}
		}
		if (rows.length > 0) {
			tables.push(this.props.tableless 
				? <div key="formtable" className="AMCFormTableless">{rows}</div> 
				: <table key="formtable"><tbody>{rows}</tbody></table>);
		}
		if (sectionrows) {
			tables.push(<fieldset key="sectionrows"><legend>{lastsection}</legend><table><tbody>{sectionrows}</tbody></table></fieldset>);
		}
		return (
			<div className="AMCForm AMCFormContainer">
				{tables}
				<div className="AMCFormCommandBar">
					{ this.props.buttons || '' }
					{ this.props.onSave ? <button className={this.props.saveButtonClassNames || "AMCButton AMCButtonOK"} onClick={this.onSave.bind(this)}>{this.props.saveButton || "Save"}</button> : '' }
					{ this.props.onDone ? <button className="AMCButton" onClick={this.props.onDone.bind(this)}>Done</button> : '' }
					{ this.props.onCancel ? <button className="AMCButton AMCButtonCancel" onClick={this.props.onCancel}>Cancel</button> : '' }
				</div>
			</div>
		)
	}
/*
	static editInPlace(event, item, protocol, field) {
		ZUtil.eatEvent(event);
		field = protocol.filter( x => { return x.field === field } )[0];
		ZLog.log("editInPlace", { protocol: protocol, field: field, item: item });
		console.log("protocol[field].kind=" + field.kind);
		ZooInPlaceEditor.editInPlace(event.target, item, protocol, field);
	}
*/
}
// UNUSED
export var ZooInPlaceEditor = {
	getEditor() {
ZLog.info("ZooInPlaceEditor this.context.editor=", { editor: this.context ? this.context.editor : null });
		return this.context ? this.context.editor : null;
	},
	cancelEdits() {
		this.context = {};
	},
	onChange(e) {
		switch (this.context.field.kind) {
			case "boolean" :
				// falls through
			case "text" :
				// falls through
			case "string" :
				let properties = {};
				properties[this.context.field.field] = e.target.value;
				let id = this.context.transman.startTransaction("user edited component");
				this.context.transman.update(properties);
				this.context.transman.endTransaction(id);
				break;
			default:
				ZLog.error("ZooInPlaceEditor - Do not know how to save this kind of field: " + this.context.field.kind);
				break;
		}
	},
	newEditor(event, item, protocol, field, position_relative_to="parent") {
		ZUtil.eatEvent(event);
		this.cancelEdits();
		this.context = {};
//		this.context.target = target;
		this.context.item = item;
		this.context.protocol = protocol;
		this.context.transman = AMCTransactionsManagerFactory.manage(item);
		this.context.field = protocol.filter( x => { return x.field === field } )[0];
		let bounds = ZUtil.getBoundingClientRect(event.target, position_relative_to);
		ZLog.log("ZooInPlaceEditor", { protocol: protocol, field: field }); // , item: item, bounds: bounds });
		console.log("protocol[field].kind=" + this.context.field.kind);
		switch (this.context.field.kind) {
			case "text" :
				this.context.editor = <textarea className="ZooInPlaceEditor" style={{left: bounds.left + "px", top: bounds.top + "px", width: bounds.width + "px", height: bounds.height + "px"}} onChange={this.onChange.bind(this)} defaultValue={item[this.context.field.field]}></textarea>
ZLog.info("ZooInPlaceEditor build editor");
				break;
			case "string" :
				this.context.editor = <input type="text" className="ZooInPlaceEditor" style={{left: bounds.left + "px", top: bounds.top + "px", width: bounds.width + "px", height: bounds.height + "px"}} onChange={this.onChange.bind(this)} defaultValue={item[this.context.field.field]}></input>
				break;
			case "boolean" :
				this.context.editor = <div className="ZooInPlaceEditorCheckbox" style={{left: bounds.left + "px", top: bounds.top + "px", width: bounds.width + "px", height: bounds.height + "px"}} ><input type="checkbox" id="zoo-in-place-checkbox" className="ZooInPlaceEditor" onChange={this.onChange.bind(this)} defaultChecked={item[this.context.field.field]}></input><label htmlFor="zoo-in-place-checkbox">{field}</label></div>
				break;
			default:
				ZLog.error("ZooInPlaceEditor - Do not know how to edit this kind of field: " + this.context.field.kind);
				break;
		}
	}

}





// WEBPACK FOOTER //
// ./src/AMCForm.js